import { Point, Rectangle } from '@shared/commons/Geometry';
import { Pen, SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { XYSeriesData } from '../Series/TerceraChartXYSeries';
import { DrawPointer, DrawPointerTypeEnum } from '../Utils/DrawPointer';
import { TerceraChartBaseRenderer } from './TerceraChartBaseRenderer';
import { LayersEnum } from '../Utils/LayersEnum';
export class TerceraChartStyledLineRenderer extends TerceraChartBaseRenderer {
    constructor(chart) {
        super(chart);
        this.LineStyle = LineStyle.Curve;
        this.isDrawPoints = false;
        this.isSelected = false;
        this.UseInAutoscale = true;
    }
    ThemeChanged() {
        super.ThemeChanged();
        this._selectedColor = ThemeManager.colors.Chart_StyledLineRenderer_SelectedColor;
    }
    Draw(gr, window, windowsContainer, advParams) {
        if (!this.Visible) {
            return;
        }
        if (isNullOrUndefined(this.ColorStyleWidth)) {
            return;
        }
        if (isNullOrUndefined(this.Series) || this.Series.Count() === 0) {
            return;
        }
        const points = this.getPoints(window);
        if (points.length === 0) {
            return;
        }
        gr.save();
        const clientRect = window.ClientRectangle;
        const rect = new Path2D();
        rect.rect(clientRect.X, clientRect.Y, clientRect.Width, clientRect.Height);
        gr.clip(rect);
        const color = this.isSelected ? this._selectedColor : this.ColorStyleWidth.Color;
        const pen = new Pen(color, this.ColorStyleWidth.Width, this.ColorStyleWidth.Style);
        switch (this.LineStyle) {
            case LineStyle.Curve:
                gr.DrawCurve(pen, points);
                break;
            case LineStyle.Line:
                gr.DrawLines(pen, points);
                break;
            case LineStyle.LineDots:
                gr.DrawLines(pen, points);
                this.DrawDots(gr, points, advParams);
                break;
        }
        gr.restore();
    }
    DrawDots(gr, points, advParams) {
        var _a;
        const color = this.isSelected ? this._selectedColor : this.ColorStyleWidth.Color;
        const lineWidth = this.ColorStyleWidth.Width;
        const brush = new SolidBrush(color);
        let closestPoint;
        let closestDistance = Number.MAX_VALUE;
        const defaultPointSize = lineWidth * 4;
        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            gr.FillEllipse(brush, point.X - defaultPointSize / 2, point.Y - defaultPointSize / 2, defaultPointSize, defaultPointSize);
            if (isValidNumber(this._hoveredX)) {
                const distance = Math.abs(this._hoveredX - point.X);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestPoint = point;
                }
            }
        }
        const selectedPointSize = defaultPointSize + 4;
        if (!isNullOrUndefined(closestPoint)) {
            gr.FillEllipse(brush, closestPoint.X - selectedPointSize / 2, closestPoint.Y - selectedPointSize / 2, selectedPointSize, selectedPointSize);
            const mainWindow = (_a = advParams === null || advParams === void 0 ? void 0 : advParams.TerceraChart) === null || _a === void 0 ? void 0 : _a.mainWindow;
            if (!isNullOrUndefined(mainWindow) && !isNullOrUndefined(mainWindow.rightYScaleRenderer)) {
                const dataY = mainWindow.PointsConverter.GetDataY(closestPoint.Y);
                advParams.DrawPointers.push(new DrawPointer(DrawPointerTypeEnum.LowPriority, dataY, brush, mainWindow.rightYScaleRenderer.FormatValue(dataY)));
            }
        }
    }
    ProcessMouseMove(e) {
        this._hoveredX = e.Location.X;
        e.NeedRedraw = LayersEnum.All;
        return super.ProcessMouseMove(e);
    }
    FindMinMax(minMax, window) {
        if (isNullOrUndefined(this.Series) || this.Series.Count() === 0) {
            return super.FindMinMax(minMax, window);
        }
        let min = Number.MAX_VALUE;
        let max = -Number.MAX_VALUE;
        for (let i = 0; i < this.Series.Count(); i++) {
            const y = this.Series.GetValue(i, XYSeriesData.Y_INDEX);
            min = Math.min(min, y);
            max = Math.max(max, y);
        }
        minMax.tMin = min;
        minMax.tMax = max;
        return true;
    }
    getPoints(window) {
        const clientRectangle = window.ClientRectangle;
        const maxDelta = 10000;
        const maxRect = new Rectangle(clientRectangle.X - maxDelta, clientRectangle.Y - maxDelta, clientRectangle.Width + 2 * maxDelta, clientRectangle.Height + 2 * maxDelta);
        const points = [];
        for (let i = 0; i < this.Series.Count(); i++) {
            const x = this.Series.GetValue(i, XYSeriesData.X_INDEX);
            const y = this.Series.GetValue(i, XYSeriesData.Y_INDEX);
            const point = new Point(window.PointsConverter.GetScreenX(x), window.PointsConverter.GetScreenY(y));
            if (maxRect.Contains(point.X, point.Y)) {
                points.push(point);
            }
        }
        return points;
    }
}
export var LineStyle;
(function (LineStyle) {
    LineStyle[LineStyle["Curve"] = 0] = "Curve";
    LineStyle[LineStyle["Line"] = 1] = "Line";
    LineStyle[LineStyle["LineDots"] = 2] = "LineDots";
})(LineStyle || (LineStyle = {}));
